module.exports = __webpack_public_path__ + "img/dcc.43c51c79.png";